import React, { useEffect } from 'react';

import { useCookieConsent } from '../hooks/useCookieConsent';
import { initClarity } from '../utils/clarity';

/** Load Microsoft Clarity only after analytics cookie consent. */
const ClarityLoader: React.FC = () => {
  const { consentState } = useCookieConsent();

  useEffect(() => {
    if (consentState.hasInteracted && consentState.analytics) {
      initClarity();
    }
  }, [consentState.hasInteracted, consentState.analytics]);

  return null;
};

export default ClarityLoader;
